export enum AnalyticsEvent {
  // Better Deal Events
  BD_WIDGET_SEE_ALL_CLICK = 'bd_widget_see_all_click',

  BD_MORTGAGE_HEADER_SEE_ALL_CLICK = 'bd_mortgage_header_see_all_click',
  BD_MORTGAGE_HEADER_CTA_CLICK = 'bd_mortgage_header_cta_click',
  BD_MORTGAGE_HEADER_CTA_PERFORMED = 'bd_mortgage_header_cta_performed',

  BD_COMPARISON_PAGE_COMPARE_TOGGLE = 'bd_comparison_page_compare_toggle',
  BD_COMPARISON_PAGE_CTA_CLICKED = 'bd_comparison_page_cta_clicked',
  BD_COMPARISON_PAGE_CTA_PERFORMED = 'bd_comparison_page_cta_performed',
  BD_COMPARISON_PAGE_SNOOZE_CLICKED = 'bd_comparison_page_snooze_clicked',
  BD_COMPARISON_PAGE_SNOOZE_PERFORMED = 'bd_comparison_page_snooze_performed',

  // Notification Events
  NOTIFICATION_RECEIVED = 'notification_received',
  NOTIFICATION_CLICKED = 'notification_clicked',

  // Page View Tracking
  SCREEN_VIEW = 'screen_view',

  // User Engagement
  APP_OPENED = 'app_opened',

  // Dimensions as Events
  PUSH_NOTIFICATIONS_ENABLED = 'push_notifications_enabled',
  BETTER_DEALS_AVAILABLE = 'better_deals_available',
  LOGGED_IN = 'logged_in',
}
